export default __webpack_public_path__ + "static/media/walet-2.e9fe6187.svg";